<template>
  <div class="message-box">
    <message-list ref="messageList"></message-list>
    <message-editor :disabled="wait" @onSend="onSend"></message-editor>
  </div>
</template>

<script>
import messageList from './messageList.vue'
import messageEditor from './messageEditor.vue'
export default {
  name: 'MessageBox',
  components: {
    MessageList: messageList,
    MessageEditor: messageEditor
  },
  props: {
    model: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      wait: false
    }
  },
  methods: {
    onSend(info) {
      let self = this
      let params = {
        uid: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        question: info,
        model: self.model
      }
      self.wait = true
      self.$refs.messageList.appendAQues(info, new Date().getTime())
      self.$refs.messageList.handleMessages()
      self.$refs.messageList.scrollToEnd()
      let temp = ''
      let time = new Date().getTime()
      self.$refs.messageList.updateATempResponce('思考中', time, true)
      this.$apis.chatrobot.ask(
        params,
        () => {
          // console.log("start ...");
          self.$refs.messageList.updateATempResponce('', time, false, true)
        },
        data => {
          temp += data.answer
          self.$refs.messageList.updateATempResponce(temp, time, false, true)
          self.$refs.messageList.scrollToEnd()
        },
        err => {
          console.log('err', err)
          self.$message.error(`发生错误：${err.answer ? err.answer : err}`)
          self.$refs.messageList.clearTempResponce()
          self.$refs.messageList.scrollToEnd()
          self.wait = false
        },
        () => {
          // console.log("finish");
          self.$refs.messageList.clearTempResponce()
          self.$refs.messageList.appendAResponce(temp, time, true)
          self.$refs.messageList.handleMessages()
          self.$refs.messageList.scrollToEnd()
          self.wait = false
        }
      )
    },
    init() {
      this.$refs.messageList.init()
    },
    close() {
      this.$refs.messageList.close()
    },
    clearMessages() {
      this.$refs.messageList.clearMessages()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.message-box {
  @include adaptation(
    (
      --message-box-min-height: 418px,
      --message-list-unavailable-height: 76px
    )
  );
  --message-box-real-height: max(100%, var(--message-box-min-height));
  --message-list-real-height: calc(
    var(--message-box-real-height) - var(--message-list-unavailable-height)
  );
  display: flex;
  flex-direction: column;
  height: var(--message-box-real-height);
  min-height: var(--message-box-min-height);
  padding: var(--base-size-24) 0 0;

  .message-list {
    flex-grow: 1;
    margin-bottom: var(--base-size-24);
    max-height: var(--message-list-real-height);
    overflow-y: scroll;
    padding: 0 var(--base-size-24) 0 var(--base-size-16);
  }

  .message-editor {
    margin: 0;
  }
}
</style>
